"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFetchMethods = void 0;
var constants_1 = require("../utils/constants");
var getFetchMethods = function (_a) {
    var apiKey = _a.apiKey, auth = _a.auth, _b = _a.baseUri, baseUri = _b === void 0 ? '' : _b, _c = _a.customHeaders, customHeaders = _c === void 0 ? {} : _c, logger = _a.logger;
    var _buildHeaders = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var headers, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    headers = __assign({}, customHeaders);
                    if (!auth) return [3 /*break*/, 2];
                    _a = headers;
                    return [4 /*yield*/, auth.getToken()];
                case 1:
                    _a.authorization = _b.sent();
                    _b.label = 2;
                case 2:
                    if (apiKey)
                        headers['x-api-key'] = apiKey;
                    if (payload) {
                        switch (true) {
                            case payload instanceof FormData:
                                break;
                            case payload instanceof URLSearchParams:
                                headers['content-type'] = 'application/x-www-form-urlencoded';
                                break;
                            default:
                                headers['content-type'] = 'application/json';
                        }
                    }
                    return [2 /*return*/, headers];
            }
        });
    }); };
    var _buildOptions = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (options, method, payload) {
            var _a;
            if (options === void 0) { options = {}; }
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = options;
                        return [4 /*yield*/, _buildHeaders(payload)];
                    case 1:
                        _a.headers = _b.sent();
                        options.method = method;
                        if (payload) {
                            switch (true) {
                                case payload instanceof FormData:
                                case payload instanceof URLSearchParams:
                                    options.body = payload;
                                    break;
                                default:
                                    options.body = JSON.stringify(payload);
                            }
                        }
                        return [2 /*return*/, options];
                }
            });
        });
    };
    var _handleResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var error, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!response.ok) return [3 /*break*/, 2];
                    return [4 /*yield*/, _parseData(response)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    _a = Error.bind;
                    return [4 /*yield*/, response.text()];
                case 3:
                    error = new (_a.apply(Error, [void 0, _b.sent()]))();
                    error.status = response.status;
                    logger === null || logger === void 0 ? void 0 : logger.error(response.url, { error: error });
                    throw error;
            }
        });
    }); };
    var _parseData = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var contentType, _a, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    contentType = response.headers.get('CONTENT-TYPE');
                    _a = true;
                    switch (_a) {
                        case contentType === null || contentType === void 0 ? void 0 : contentType.includes(constants_1.API_CONTENT_TYPES.JSON): return [3 /*break*/, 1];
                        case (contentType === null || contentType === void 0 ? void 0 : contentType.includes(constants_1.API_CONTENT_TYPES.TEXT)) || (contentType === null || contentType === void 0 ? void 0 : contentType.includes(constants_1.API_CONTENT_TYPES.XML)): return [3 /*break*/, 4];
                    }
                    return [3 /*break*/, 6];
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    error_1 = _b.sent();
                    logger === null || logger === void 0 ? void 0 : logger.error('Response has JSON header, but contains invalid JSON', { error: error_1 });
                    return [2 /*return*/, response];
                case 4: return [4 /*yield*/, response.text()];
                case 5: return [2 /*return*/, _b.sent()];
                case 6: return [2 /*return*/, response];
            }
        });
    }); };
    var del = function (path, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = fetch;
                    _b = [baseUri + path];
                    return [4 /*yield*/, _buildOptions(options, 'DELETE')];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()])).then(_handleResponse)];
            }
        });
    }); };
    var get = function (path, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = fetch;
                    _b = [baseUri + path];
                    return [4 /*yield*/, _buildOptions(options, 'GET')];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()])).then(_handleResponse)];
            }
        });
    }); };
    var patch = function (path, payload, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = fetch;
                    _b = [baseUri + path];
                    return [4 /*yield*/, _buildOptions(options, 'PATCH', payload)];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()])).then(_handleResponse)];
            }
        });
    }); };
    var post = function (path, payload, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = fetch;
                    _b = [baseUri + path];
                    return [4 /*yield*/, _buildOptions(options, 'POST', payload)];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()])).then(_handleResponse)];
            }
        });
    }); };
    var put = function (path, payload, options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = fetch;
                    _b = [baseUri + path];
                    return [4 /*yield*/, _buildOptions(options, 'PUT', payload)];
                case 1: return [2 /*return*/, _a.apply(void 0, _b.concat([_c.sent()])).then(_handleResponse)];
            }
        });
    }); };
    return { del: del, get: get, patch: patch, post: post, put: put };
};
exports.getFetchMethods = getFetchMethods;
//# sourceMappingURL=index.js.map